import { render, staticRenderFns } from "./QueryPhotos.vue?vue&type=template&id=67b027bd&scoped=true"
import script from "./QueryPhotos.vue?vue&type=script&lang=js"
export * from "./QueryPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b027bd",
  null
  
)

export default component.exports